import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/navigation.css';

export const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="main-nav">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          PoE2 Skills AI
        </Link>
        
        <button 
          className="mobile-menu-button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>

      <div className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
        <Link to="/" className="nav-link">Home</Link>
        <Link to="/poe2skilltreeplanner" className="nav-link">PoE2 Skill Tree Planner</Link>
        <Link to="/skills" className="nav-link">Skill Gems</Link>
        <Link to="/supports" className="nav-link">Support Gems</Link>
        <Link to="/spirits" className="nav-link">Spirit Gems</Link>
        <Link to="/poe2skillplanner" className="nav-link">PoE2 Skills Planner</Link>
        <Link to="/videos" className="nav-link">Videos</Link>
        <Link to="/articles" className="nav-link">Articles</Link>
        <Link to="/about" className="nav-link">About</Link>
      </div>
    </nav>
  );
};